import { Box, Flex, Image, Text } from "rebass/styled-components";
import styled from "styled-components";
import { IoMdCheckmark } from "react-icons/io";
import { useHistory } from "react-router-dom";
import { Button } from "MVVM/Components/Button";
import AllstarIcon from "../../../../../../assets/images/brand/Wordmark-Light-Tag.png";
import { URLS } from "MVVM/Utilities/Maps";
import { analytics } from "MVVM/Analytics";
import { withReturn } from "MVVM/Utilities/Auth/loginRedirect";

export const SignupToCreate = () => {
  const history = useHistory();
  return (
    <StyledBox>
      <Flex
        flexDirection="column"
        padding={7}
        justifyContent={"space-between"}
        alignItems={"center"}
        style={{ gap: 20 }}
        maxWidth={400}
      >
        <StyledAllstarIcon src={AllstarIcon} />
        <Text variant="text.headingMedium" textAlign={"center"} mb={3}>
          Login or signup to create from Match History!
        </Text>
        <Row>
          <StyledCheckmark color="envy" />
          <Text variant={"text.paragraphMedium"}>
            Quickly create clips of all your best moments from any match
          </Text>
        </Row>
        <Row>
          <StyledCheckmark color="envy" />
          <Text variant={"text.paragraphMedium"}>
            Create highlight reels from entire matches to look & feel like a pro
          </Text>
        </Row>
        <Row>
          <StyledCheckmark color="envy" />
          <Text variant={"text.paragraphMedium"}>
            View & share all your clips from your profile, and Remix to add
            custom effects
          </Text>
        </Row>

        <Button
          mt={3}
          onClick={() => {
            analytics.track("Match History - Signup to Create");
            history.push(withReturn(URLS.SIGNUP));
          }}
        >
          Create Account
        </Button>

        <Flex style={{ gap: 10 }}>
          <Text variant={"text.labelMedium"}>Already a member?</Text>
          <LoginText
            variant={"text.labelMedium"}
            color="envy"
            mr={4}
            onClick={() => {
              history.push(withReturn(URLS.LOGIN));
            }}
          >
            Log in
          </LoginText>
        </Flex>
      </Flex>
    </StyledBox>
  );
};

const LoginText = styled(Text)`
  cursor: pointer;
`;

const StyledCheckmark = styled(IoMdCheckmark)`
  color: ${({ theme }) => theme.colors.envy};
  fill: ${({ theme }) => theme.colors.envy};
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`;
const StyledBox = styled(Box)`
  border-radius: 16px;
  mix-blend-mode: normal;
  width: 100%;
  border-color: #233438;
  border-style: solid;
  border-width: 1px;
  box-shadow: 0 0 30px #233438;
  background-color: #10161a;
  max-width: 400px;
`;

const StyledAllstarIcon = styled(Image)`
  width: 110px;
`;

const Row = styled(Flex)`
  align-items: start;
  justify-content: start;
  gap: 15px;
`;
